import React from "react";
import { connect } from "react-redux";
import { Text } from "ui-components";

import { SidebarWrapper, Header, StepsWrapper } from "@common/styled/sidebar";
import Stepper from "@common/components/Stepper";

const Sidebar = ({ section, stepsMeta }) => {
  return (
    <SidebarWrapper>
      <Header>
        <Text type="medium" size="3">
          Community Care Violence Assessment Tool
        </Text>
      </Header>
      <StepsWrapper>
        <Stepper section={section} stepsMeta={stepsMeta} />
      </StepsWrapper>
    </SidebarWrapper>
  );
};

const mapStateToProps = state => {
  return {
    stepsMeta: state.workerHome.sidebar.stepsMeta,
    section: state.workerHome.app
  };
};

const SidebarContainer = connect(mapStateToProps, null)(Sidebar);
export default SidebarContainer;



// WEBPACK FOOTER //
// ./src/workerhome/components/Sidebar/SidebarContainer.jsx